import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styles from "./index.module.css";
export const ShowBookItem = ({ book, onClick }) => {
    return (_jsxs("button", { className: styles.book, onClick: onClick, children: [_jsxs("p", { className: styles.bookTitle, children: ["(#", book.id, ") ", book.title] }), _jsxs("p", { children: ["\u0410\u0432\u0442\u043E\u0440: ", book.author] }), _jsx("div", { className: styles.bookFooter, children: book.available ? "доступна" : "выдана" })] }));
};
